import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=9ede5b78&scoped=true&"
import script from "./editinfo.js?vue&type=script&lang=js&"
export * from "./editinfo.js?vue&type=script&lang=js&"
import style0 from "./EditInfo.vue?vue&type=style&index=0&id=9ede5b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ede5b78",
  null
  
)

export default component.exports